import { useSessionStore } from '../../stores/session/sessionStore';

/**
 * Whether the connected data source can produce automatic attachments (invoice PDFs, statements) at all.
 * A desktop session reads from the Acomba bridge, which serves none — so the answer is a permanent "no",
 * not "none this time".
 *
 * Keyed on the session kind, which is a proxy for the data source: it would answer wrongly for a portal
 * login against a company whose data was synced by the bridge. Use it only to decide whether an *absence*
 * of attachments is worth telling the user about — never whether to send.
 */
export function supportsAutoAttachments(): boolean {
    return useSessionStore.getState().sessionKind !== 'desktop';
}
